var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServDesk5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 182,
    viewBox: "0 0 354 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_986)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 354,
    height: 182,
    rx: 8,
    fill: "#61C4B7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 24,
    width: 64,
    height: 64,
    fill: "#EB7565"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 40,
    r: 14,
    stroke: "#030303",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 56,
    r: 14,
    stroke: "#FFF7F0",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298,
    y: 56,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 56,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 56,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298,
    y: 80,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 80,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 80,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298,
    y: 84,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 84,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 84,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298,
    y: 24,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 24,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 24,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298,
    y: 28,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 28,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 28,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298,
    y: 52,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 52,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 52,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266 56L298 88V56H266Z",
    fill: "#FFF7F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266 56L298 88V56H266Z",
    fill: "#552049"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202 88L170 56V88H202Z",
    fill: "#F39E9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266 56L298 24V56H266Z",
    fill: "#FFF7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.588 153H28.852V146.4H32.26C33.476 146.4 34.548 146.184 35.476 145.752C36.404 145.304 37.132 144.656 37.66 143.808C38.204 142.96 38.476 141.944 38.476 140.76C38.476 139.544 38.212 138.52 37.684 137.688C37.156 136.856 36.42 136.224 35.476 135.792C34.548 135.344 33.476 135.12 32.26 135.12H25.588V153ZM28.852 143.52V138H32.308C33.188 138 33.892 138.248 34.42 138.744C34.948 139.24 35.212 139.912 35.212 140.76C35.212 141.592 34.948 142.264 34.42 142.776C33.892 143.272 33.188 143.52 32.308 143.52H28.852ZM40.8865 153H44.0305V145.344C44.0305 144.496 44.2785 143.816 44.7745 143.304C45.2705 142.792 45.9025 142.536 46.6705 142.536C47.4385 142.536 48.0705 142.792 48.5665 143.304C49.0625 143.8 49.3105 144.48 49.3105 145.344V153H52.4545V144.6C52.4545 143.624 52.2465 142.768 51.8305 142.032C51.4145 141.28 50.8305 140.696 50.0785 140.28C49.3425 139.864 48.4945 139.656 47.5345 139.656C46.7825 139.656 46.1025 139.792 45.4945 140.064C44.8865 140.32 44.3985 140.712 44.0305 141.24V134.832H40.8865V153ZM61.4971 153.288C62.7611 153.288 63.9131 153 64.9531 152.424C65.9931 151.832 66.8251 151.024 67.4491 150C68.0731 148.96 68.3851 147.784 68.3851 146.472C68.3851 145.16 68.0731 143.992 67.4491 142.968C66.8411 141.944 66.0171 141.136 64.9771 140.544C63.9371 139.952 62.7771 139.656 61.4971 139.656C60.2011 139.656 59.0331 139.952 57.9931 140.544C56.9531 141.136 56.1211 141.944 55.4971 142.968C54.8891 143.992 54.5851 145.16 54.5851 146.472C54.5851 147.784 54.8891 148.952 55.4971 149.976C56.1211 151 56.9531 151.808 57.9931 152.4C59.0491 152.992 60.2171 153.288 61.4971 153.288ZM61.4971 150.408C60.7931 150.408 60.1611 150.24 59.6011 149.904C59.0571 149.568 58.6251 149.104 58.3051 148.512C58.0011 147.904 57.8491 147.224 57.8491 146.472C57.8491 145.72 58.0011 145.048 58.3051 144.456C58.6251 143.864 59.0571 143.4 59.6011 143.064C60.1611 142.712 60.7931 142.536 61.4971 142.536C62.2011 142.536 62.8171 142.712 63.3451 143.064C63.8891 143.4 64.3131 143.864 64.6171 144.456C64.9371 145.048 65.0971 145.72 65.0971 146.472C65.0971 147.224 64.9371 147.904 64.6171 148.512C64.3131 149.104 63.8891 149.568 63.3451 149.904C62.8171 150.24 62.2011 150.408 61.4971 150.408ZM76.4869 153.144C77.0149 153.144 77.5349 153.104 78.0469 153.024V150.312C77.7429 150.36 77.4629 150.384 77.2069 150.384C76.4389 150.384 75.8789 150.208 75.5269 149.856C75.1749 149.504 74.9989 149 74.9989 148.344V142.752H77.9989V139.944H74.9989V136.968H71.8549V137.976C71.8549 138.616 71.6789 139.104 71.3269 139.44C70.9749 139.776 70.4789 139.944 69.8389 139.944H69.5989V142.752H71.8549V148.512C71.8549 149.968 72.2549 151.104 73.0549 151.92C73.8709 152.736 75.0149 153.144 76.4869 153.144ZM86.7158 153.288C87.9798 153.288 89.1318 153 90.1718 152.424C91.2118 151.832 92.0438 151.024 92.6678 150C93.2918 148.96 93.6038 147.784 93.6038 146.472C93.6038 145.16 93.2918 143.992 92.6678 142.968C92.0598 141.944 91.2358 141.136 90.1958 140.544C89.1558 139.952 87.9958 139.656 86.7158 139.656C85.4198 139.656 84.2518 139.952 83.2118 140.544C82.1718 141.136 81.3398 141.944 80.7158 142.968C80.1078 143.992 79.8038 145.16 79.8038 146.472C79.8038 147.784 80.1078 148.952 80.7158 149.976C81.3398 151 82.1718 151.808 83.2118 152.4C84.2678 152.992 85.4358 153.288 86.7158 153.288ZM86.7158 150.408C86.0118 150.408 85.3798 150.24 84.8198 149.904C84.2758 149.568 83.8438 149.104 83.5238 148.512C83.2198 147.904 83.0678 147.224 83.0678 146.472C83.0678 145.72 83.2198 145.048 83.5238 144.456C83.8438 143.864 84.2758 143.4 84.8198 143.064C85.3798 142.712 86.0118 142.536 86.7158 142.536C87.4198 142.536 88.0358 142.712 88.5638 143.064C89.1078 143.4 89.5318 143.864 89.8358 144.456C90.1558 145.048 90.3158 145.72 90.3158 146.472C90.3158 147.224 90.1558 147.904 89.8358 148.512C89.5318 149.104 89.1078 149.568 88.5638 149.904C88.0358 150.24 87.4198 150.408 86.7158 150.408ZM102.324 158.28C103.572 158.28 104.676 158.024 105.636 157.512C106.596 157 107.348 156.296 107.892 155.4C108.436 154.504 108.708 153.488 108.708 152.352V139.944H105.732V141.456C104.74 140.256 103.404 139.656 101.724 139.656C100.524 139.656 99.4521 139.936 98.5081 140.496C97.5641 141.04 96.8201 141.792 96.2761 142.752C95.7321 143.712 95.4601 144.808 95.4601 146.04C95.4601 147.256 95.7321 148.352 96.2761 149.328C96.8201 150.304 97.5721 151.072 98.5321 151.632C99.4921 152.192 100.58 152.472 101.796 152.472C103.38 152.472 104.636 151.96 105.564 150.936V152.352C105.564 153.312 105.26 154.056 104.652 154.584C104.044 155.128 103.268 155.4 102.324 155.4C101.492 155.4 100.788 155.208 100.212 154.824C99.6521 154.456 99.2761 153.968 99.0841 153.36L96.1561 154.464C96.5721 155.616 97.3321 156.536 98.4361 157.224C99.5561 157.928 100.852 158.28 102.324 158.28ZM102.18 149.568C101.172 149.568 100.34 149.24 99.6841 148.584C99.0441 147.912 98.7241 147.072 98.7241 146.064C98.7241 145.392 98.8681 144.792 99.1561 144.264C99.4601 143.72 99.8761 143.296 100.404 142.992C100.932 142.688 101.524 142.536 102.18 142.536C103.172 142.536 103.98 142.872 104.604 143.544C105.244 144.2 105.564 145.04 105.564 146.064C105.564 147.088 105.244 147.928 104.604 148.584C103.98 149.24 103.172 149.568 102.18 149.568ZM111.644 153H114.788V145.728C114.788 144.736 115.06 143.968 115.604 143.424C116.164 142.864 116.884 142.584 117.764 142.584H118.892V139.8H118.124C117.324 139.8 116.62 139.944 116.012 140.232C115.404 140.52 114.932 141.04 114.596 141.792V139.944H111.644V153ZM124.581 153.288C126.277 153.288 127.637 152.728 128.661 151.608V153H131.637V144.312C131.637 143.4 131.405 142.592 130.941 141.888C130.477 141.184 129.837 140.64 129.021 140.256C128.221 139.856 127.285 139.656 126.213 139.656C124.901 139.656 123.733 139.968 122.709 140.592C121.685 141.216 120.981 142.04 120.597 143.064L123.165 144.312C123.405 143.72 123.781 143.248 124.293 142.896C124.805 142.528 125.405 142.344 126.093 142.344C126.813 142.344 127.389 142.536 127.821 142.92C128.269 143.288 128.493 143.752 128.493 144.312V144.744L124.605 145.368C123.069 145.624 121.933 146.112 121.197 146.832C120.461 147.552 120.093 148.456 120.093 149.544C120.093 150.696 120.501 151.608 121.317 152.28C122.133 152.952 123.221 153.288 124.581 153.288ZM123.357 149.424C123.357 148.512 123.973 147.936 125.205 147.696L128.493 147.144V147.672C128.493 148.568 128.181 149.328 127.557 149.952C126.949 150.576 126.149 150.888 125.157 150.888C124.629 150.888 124.197 150.76 123.861 150.504C123.525 150.232 123.357 149.872 123.357 149.424ZM134.543 157.8H137.687V151.752C138.167 152.248 138.751 152.632 139.439 152.904C140.127 153.16 140.871 153.288 141.671 153.288C142.935 153.288 144.063 152.992 145.055 152.4C146.047 151.792 146.831 150.976 147.407 149.952C147.983 148.912 148.271 147.752 148.271 146.472C148.271 145.192 147.983 144.04 147.407 143.016C146.831 141.976 146.047 141.16 145.055 140.568C144.063 139.96 142.943 139.656 141.695 139.656C140.799 139.656 139.991 139.816 139.271 140.136C138.551 140.456 137.959 140.904 137.495 141.48V139.944H134.543V157.8ZM141.311 150.408C140.623 150.408 139.999 150.24 139.439 149.904C138.895 149.568 138.463 149.104 138.143 148.512C137.839 147.92 137.687 147.24 137.687 146.472C137.687 145.704 137.839 145.024 138.143 144.432C138.463 143.84 138.895 143.376 139.439 143.04C139.999 142.704 140.623 142.536 141.311 142.536C142.031 142.536 142.663 142.712 143.207 143.064C143.767 143.4 144.207 143.864 144.527 144.456C144.847 145.048 145.007 145.72 145.007 146.472C145.007 147.224 144.847 147.904 144.527 148.512C144.207 149.104 143.767 149.568 143.207 149.904C142.663 150.24 142.031 150.408 141.311 150.408ZM150.668 153H153.812V145.344C153.812 144.496 154.06 143.816 154.556 143.304C155.052 142.792 155.684 142.536 156.452 142.536C157.22 142.536 157.852 142.792 158.348 143.304C158.844 143.8 159.092 144.48 159.092 145.344V153H162.236V144.6C162.236 143.624 162.028 142.768 161.612 142.032C161.196 141.28 160.612 140.696 159.86 140.28C159.124 139.864 158.276 139.656 157.316 139.656C156.564 139.656 155.884 139.792 155.276 140.064C154.668 140.32 154.18 140.712 153.812 141.24V134.832H150.668V153ZM166.244 158.304C167.476 158.304 168.5 157.952 169.316 157.248C170.148 156.56 170.812 155.584 171.308 154.32L176.996 139.944H173.588L170.228 148.944L166.844 139.944H163.46L168.62 153L168.332 153.696C168.076 154.24 167.78 154.68 167.444 155.016C167.124 155.352 166.604 155.52 165.884 155.52C165.628 155.52 165.356 155.496 165.068 155.448C164.78 155.416 164.524 155.368 164.3 155.304V157.944C164.572 158.072 164.876 158.16 165.212 158.208C165.548 158.272 165.892 158.304 166.244 158.304Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 354,
    height: 182,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServDesk5);
export default __webpack_public_path__ + "static/media/serv_desk5.c64e8f171441392d1e7201f888157f2e.svg";
export { ForwardRef as ReactComponent };